import lang from 'dojo/_base/lang';
import topic from 'dojo/topic';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './LoginForm.html?raw';
import on from 'dojo/on';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import LangSelect from '../../../moreCore/System/LanguageSelector';
import "../../../moreCore/System/LanguageSelector";
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import SimpleFileUpload from '../../UI/SimpleFileUpload/SimpleFileUpload';
import "../../UI/SimpleFileUpload/SimpleFileUpload";
import CheckBox from '../../UI/CheckBox/CheckBox';
import "../../UI/CheckBox/CheckBox";
import UserSubstitutionForm from './UserSubstitution';
import "./UserSubstitution";
import UserProfileForm from '../../../WidgetCollection/User/UserProfileForm/UserProfileFormV2';
import GoogleSyncManager from '../../../WidgetCollection/GoogleSyncManager/GoogleSyncManager';
import ThemeToggler from '../ThemeToggler';
import FloatingMenu from '../../../moreCore/UI/Floating/Menu';
import PasswordChangeHome from '../../../moreCore/UI/PasswordChange/PasswordChangeHome';
import MusicianProfileForm from '../../../WidgetCollection/MusicianProfileForm/MusicianProfileForm';
import UserInfoContainer from '../../../WidgetCollection/User/UserInfo/UserInfoContainer';
import "../../../WidgetCollection/User/UserInfo/UserInfoContainer";
import Button from '../../UI/Button/Button';
import "../../UI/Button/Button";
import MDSCprofileEditor from '../../../WidgetCollection/MDS_Connect/MDSCprofileEditor';
import confpan from '../../../WidgetCollection/ms_teams/confpan/confpan';
import CommunicationObjectList from '../../../WidgetCollection/CommunicationObject/CommunicationObjectList';
import domClass from 'dojo/dom-class';
import GenericEntityView from '../../UI/EntityBased/EntityView/GenericEntityView';


type loginState = "loggedIn" | "loggingIn" | "loggingOut" | "loggedOut" | "forwardingAfterLogin";
class LoginForm extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private userInfoContainer: MdsLax<InstanceType<typeof UserInfoContainer>>;

    private userSubstitutionForm: MdsLax<InstanceType<typeof UserSubstitutionForm>>;
    private sectionSubstitution: HTMLElement;

    private langSelect: MdsLax<InstanceType<typeof LangSelect>>; // TODO!!

    private pageLinks: Array<Object> = [];
    private redirect: string | boolean = null;
    private currentSession: SessionData = null;
    private sessionID: string = null;

    //sidebar: dijit.registry.byId(this._sidebarWidgetId),

    private cbRememberLogin: MdsLax<InstanceType<typeof CheckBox>>;
    private containerRememberLogin: HTMLElement;

    //private substituteUserInfoContainer: HTMLElement;
    //private substituteUsertext: HTMLElement;

    //private usertext: HTMLElement;
    //private userDisplaytext: HTMLElement;
    private btnLogout: MdsLax<InstanceType<typeof Button>>;
    private btnLogin: MdsLax<InstanceType<typeof Button>>;
    //private iconNode: HTMLElement;
    private messageNode: HTMLElement;
    private logoutContainer: HTMLElement;
    private loginContainer: HTMLElement;
    private loginHeaderContainer: HTMLElement;
    private resetPasswordContainer: HTMLElement;

    private sectionDeveloper: HTMLElement;
    private txtFeatures: HTMLElement;

    private sectionThemeToggle: HTMLElement;


    private inputPassword: HTMLInputElement;
    private inputUsername: HTMLInputElement;
    private inputFeaturepath: HTMLInputElement;

    private twoFactorCodeContainer: HTMLDivElement;
    private inputTwoFactorCode: HTMLInputElement;

    private samlLoginButtonContainer:HTMLDivElement;
    //private passwordChange:PasswordChangeHome;
    private MoreOptionsElement:HTMLDivElement;
    private mdscLoginButtonContainer: HTMLDivElement;

    private hubBtnContainer: HTMLElement;

    private sectionMyProfile:HTMLElement;
    private myProfileEntityView: HTMLElement;
    private entityView: MdsLax<InstanceType<typeof GenericEntityView>>;

    private handleAutomaticLogin() {
        let encryptedLoginData = this.getUrlParameterValue("loginData");

        if (encryptedLoginData == false) {
            return;
        }

        domClass.add(this.domNode, "autoLogin");

        this.removeUrlParameter("loginData");

        let uri_decoded_LoginData = window.decodeURIComponent(encryptedLoginData);

        if (uri_decoded_LoginData != null) {

            let url = window.appRoot + "session/open?encryptedData=";

            this.RequestManager.post(url, {
                encryptedData: uri_decoded_LoginData
            },
                lang.hitch(this, this._onOpenSessionResponse),
                lang.hitch(this, this._onOpenSessionError)
            )

        }
    }


    private _handleLoginResponse(response: SessionData & TwoFactorProperties, reloadLocationIfSuccessful: boolean) {

        //console.log("_handleLoginResponse", response, reloadLocationIfSuccessful, this.RedirectToHomeAction);

        if (this._initialStandbyHandle != null) {
            clearTimeout(this._initialStandbyHandle);
            this._initialStandbyHandle = null;
        }



        this.StandbyStop();

        this._loginRequestHandle = null;

        if (response == null) {
            return;
        }
        if (response.Exception == false) {

            //if (response.IsTwoFactorAuthMandatory && !response.IsTwoFactorAuthEnabled) {
            //    // 2FA erzwingen!
            //    this._onClick_setUp2FAuth();
            //    this.disableNode(this.domNode);
            //    this.showToast(this.translate("TwoFactorAuthenticator__enable2FactorAuth_btnLabel") + ": " + this.translate("LoginForm__ForwardingMessage"));
            //    return;
            //}

            //console.log("loginform response", response);

            // Infos anzeigen
            //this.UiModder.domAttr.set(this.usertext, "innerHTML", response.UserDisplayName);
            //this.UiModder.domClass.remove(this.userInfoContainer, "w3-hide");


            this.sessionID = response.Session.Id;


            //let login_message = this.translations["LoginForm__LoginStatusMessage"].format(response.UserDisplayName, response.UserName);
            //this.showMessage(login_message);

            //console.log("loginform redirect", location.href, this.redirect);
            let redir = this.redirect;
            if (typeof (redir) == "string" && redir.length > 0) {
                //this.showMessage(this.translations["LoginForm__ForwardingMessage"]);
                this.showMessage(this.translate("LoginForm__ForwardingMessage"));
                location.href = window.appRoot + redir;
                //setTimeout(function () {
                //    location.reload(); //
                //}, 1000)

                return;
            }

            if (reloadLocationIfSuccessful === true) {
                this.showMessage(this.translate("LoginForm__ForwardingMessage"));

                setTimeout(function () {
                    location.reload(); //
                }, 1000)
            } else if (reloadLocationIfSuccessful === false) {
                if (window.sessionInfo) {
                    //window.sessionInfo.getProfilepicData(lang.hitch(this, this.setProfilePic));
                }
            } else { // kann auch null sein direkt nach frischem Login -> dann weiter zur Hauptnavigation
                if (!this.hasUserRole("_DEV")) { // sollte man steuerbar machen, will vielleicht nicht jeder Kunde
                    location.href = window.appRoot + "home/start";
                }
            }
        } else {
            this._setStyles();
            if (typeof (response.ErrorMessage) != "undefined") {
                //domAttr.set(this.node_login_error, "innerHTML", response.ErrorMessage);
                this.showMessage(response.ErrorMessage, true);
            }
            //domAttr.set(this.messageNodenode_login_message, "innerHTML", null);
        }


    }

    //private setProfilePic(data) {

    //    //if (data) {
    //    //    console.debug("loginform setprofilpic", data.checksum);
    //    //}

    //    let userIcon = this.iconNode;

    //    if (userIcon) {
    //        this.UiModder.domConstruct.empty(userIcon);
    //    }

    //    if (data) {
    //        if (userIcon && data.base64) {
    //            let picOverlay = this.UiModder.domConstruct.create("img", {
    //                "src": "data:image/jpeg;base64," + data.base64,
    //                "className": "profilePic round"
    //            }, userIcon);
    //        }
    //    }
    //}

    private _onChange_PrivacyCheckbox() {
        this._setLoginButtonStyle();
    }

    private _setLoginButtonStyle() {
        let checked = true;//domAttr.get(this.node_userlogin_privacy_ok, "checked");
        //console.log("privacy: ", checked);
        let value = this.UiModder.domAttr.get(this.inputPassword, "value")
        checked = checked && value != null && value != "";

        value = this.UiModder.domAttr.get(this.inputUsername, "value")
        checked = checked && value != null && value != "";

        this.btnLogin.setReadonly(!checked);
    }

    //private _checkProfilePicFeature() {
    //    let bFeature = this.hasFeature("System/UserProfilePic");

    //    this.UiModder.domClass.toggle(this.iconNode, "fa-user", !bFeature);
    //    this.UiModder.domClass.toggle(this.iconNode, "fa-user-circle", bFeature);

    //    this.UiModder.domClass.toggle(this.iconNode, "noInteraction", !bFeature);
    //    this.UiModder.domClass.toggle(this.iconNode.parentElement, "noInteraction", !bFeature);
    //    //this.floatMenuConf["changeProfilePic"].use = bFeature;
    //}

    private async _onClick_Login(evt) {
        await this.requestCookiePermission();
        this.executeLogin();
    }

    private async requestCookiePermission(){
        if (typeof window["requestCookiePermissionSuccess"] == 'boolean')
        {
            if (window["requestCookiePermissionSuccess"] == true){
                return;
            }
        }
        let canWriteCookies = true;
        //permission check fuer safari und evtl. in zukunft auch andere...
        if (window.self !== window.top) { //ist in iframe
            canWriteCookies = false;
            if (document.requestStorageAccess) {
                if (document.hasStorageAccess) {
                    try {
                        canWriteCookies = await document.hasStorageAccess();
                    } catch {
                        canWriteCookies = false;
                    }
                }
                if (!canWriteCookies) {
                    try {
                        await document.requestStorageAccess();
                        canWriteCookies = true;
                    } catch (e){
                        canWriteCookies = false;
                    }
                }

                if (canWriteCookies != true) {
                    this.showToast(this.translate("LoginForm_Warn_CannotWriteCookie"), "fas fa-exclamation")
                }
            }
        }
        if (canWriteCookies){
            window["requestCookiePermissionSuccess"] = true;
        }
        return canWriteCookies;
    }

    private async _onClick_Login_Saml(ev:Event){
        await this.requestCookiePermission();
        //wir leiten weiter auf den controller von Sustainsys.Saml2.Mvc wo automatisch Saml2 login ge-handelt wird, falls richtig configuriert wurde
        //https://saml2.sustainsys.com/en/v2/configuration.html
        //wegen cookies muessen wir ein top-level navigation hier triggeren
        let clickElem = document.createElement("a");
        clickElem.href = window.appRoot + "Saml2/SignIn";
        clickElem.classList.add("w3-hide");
        this.domNode.appendChild(clickElem);
        clickElem.click();
        this.domNode.removeChild(clickElem);
    }

    private async _onClick_Login_MDSConnect(ev:Event){
        let signInWillWork = await this.requestCookiePermission();
        let currentDomain = window.location.origin;
        let mdsConnectDomain = "";
        let resp:string|object|null = await new Promise((resolve, reject)=>{
            this.RequestManager.get(
                window.location.origin + window.appRoot + 'MDSConnectAuth/GetTid',
                (response: any) => { resolve(response) }, //callback function
                (response: any) => { reject(response); }, //error callback function
                null
            );
        });
        if ((typeof resp != 'string') && (typeof resp != 'object') ){
            console.error("invalid tid object recieved from controler:", resp);
            this.showToast(this.translate("MDSConnect_UnknownError"), "fas fa-bomb")
            return;
        }
        if (typeof resp == 'string'){
            resp = JSON.parse(resp);
        }
        if (!Object.keys(resp).includes("success") || !Object.keys(resp).includes("mdscUrl")) {
            console.error("invalid tid object recieved from controler:", resp);
            this.showToast(this.translate("MDSConnect_UnknownError"), "fas fa-bomb")
            return;
        }
        if (resp["success"] != true){
            console.error("invalid tid object recieved from controler:", resp);
            this.showToast(this.translate("MDSConnect_NotConfiguredError"), "fas fa-lock");
            return;
        }

        mdsConnectDomain = resp["mdscUrl"];
        if (mdsConnectDomain.endsWith("api/v1/")) {
            mdsConnectDomain = mdsConnectDomain.replace(/api\/v1\/$/, '');
        }

        let tid:string = resp["tid"];
        let myUri: string = window.location.origin + window.appRoot;
        mdsConnectDomain = mdsConnectDomain + "?target=" + encodeURIComponent(tid)
                            + "&targetUrl=" + encodeURI(myUri);

        const popup = window.open(
            mdsConnectDomain,
            "_blank",
            "width=527,height=583,menubar=no,toolbar=no,location=no,resizable=no,directories=no,status=no"
        );
        if (!popup || popup.closed || typeof popup.closed === 'undefined') {
            //popups nicht erlaubt, einfach redirecten
            window.location.href = mdsConnectDomain;
        }else{
            //popup erlaubt
            window.addEventListener("message", (ev: MessageEvent) => {
                if (ev.origin === currentDomain) {
                    if (ev.data && ev.data["authSuccess"]) { //wird in redirect.html gesendet (siehe Content ordner)
                        console.info("reload signal recieved from mdsc auth-flow!");
                        if (popup) {
                            popup.close();
                        }
                        window.location.reload();
                    }
                }
            });
            try {
                popup.focus();
            } catch { }
        }
    }
    private _loginRequestHandle: dojo.request.Promise<any> = null;
    private executeLogin() {

        this._setStyles("loggingIn");
        topic.publish("/Session/Loading", true);

        let inputUsername = this.inputUsername;
        let inputPassword = this.inputPassword;

        this.RequestManager.additionalErrorProperties = ["TwoFactorProblem", "TwoFactorPassthroughLogin", "TwoFactorLoginAttempted"];

        this.showMessage(null);

        this._loginRequestHandle = this.RequestManager.post(window.appRoot + "session/open", {
            "username": this.UiModder.domAttr.get(inputUsername, "value"),
            "password": this.UiModder.domAttr.get(inputPassword, "value"),
            "RememberLogin": this.cbRememberLogin.getValue() == true,
            "TwoFactorCode": this.UiModder.domAttr.get(this.inputTwoFactorCode, "value")
        },
            lang.hitch(this, this._onOpenSessionResponse),
            lang.hitch(this, this._onOpenSessionError)
        );

    }
    private _onOpenSessionResponse(response: SessionData & TwoFactorProperties) {
        //console.log("loginform _onOpenSessionResponse", response, this.getUrlAction().toLowerCase());
        //debugger;
        topic.publish("/Session/Loading", false);
        this.showMessage("");
        topic.publish("/Session/Open", { sessionData: response });//

        let bRedirect = this._checkReload(response);
        if (bRedirect != true) bRedirect = null;

        this._handleLoginResponse(response, bRedirect);

        this._setStyles("loggedIn");
    }

    private _onOpenSessionError(error: more.requestErrorMessage & TwoFactorProperties) {
        topic.publish("/Session/Loading", false);

        domClass.remove(this.domNode, "automaticLogin");

        this._loginRequestHandle = null;

        if (error.TwoFactorProblem === true) {
            this.hideNode(this.twoFactorCodeContainer, false);

            this.disableNode(this.inputUsername);
            this.disableNode(this.inputPassword);
            this.disableNode(this.cbRememberLogin);

            this.disableNode(this.loginContainer, false);

            this.disableNode(this.btnLogin);
            this.inputTwoFactorCode.focus();
            this.inputTwoFactorCode.select();
            //this.inputTwoFactorCode.oninput = lang.hitch(this, this._onInputTwoFactor);
            on(this.inputTwoFactorCode, "keyup", lang.hitch(this, this._onInputTwoFactor));
            if (error.TwoFactorLoginAttempted == true) {
                let message = error.Message;
                //if (error.TwoFactorPassthroughLogin) {
                //    message += "<br>" + error.TwoFactorPassthroughLogin;
                //}
                this.showMessage(error.Message, true);

            }

        } else {
            this._setStyles();

            this.showMessage(error.Message, true);

        }

    }

    private _onInputTwoFactor() {

        this.disableNode(this.btnLogin, !this.inputTwoFactorCode.value);
    }

    private logout_exec() {
        this.btnLogout.setReadonly(true);
        //this.UiModder.domClass.add(this.userInfoContainer, "w3-hide");

        let sessionID = this.sessionID;

        this._setStyles("loggingOut");


        if (window.sessionInfo) {
            window.sessionInfo.closeSession();
            return;
        }

        this.RequestManager.post(window.appRoot + "session/close",
            {
                "sessionid": sessionID
            },
            lang.hitch(this, this._onCloseSessionResponse),
            lang.hitch(this, this._onCloseSessionError)
        );
    }


    private _onCloseSessionResponse(response) {

        this._setStyles("loggedOut");

        this.showMessage(this.translate("LoginForm__LoggedOut"));

        this.sessionID = null;

        topic.publish("/Session/Close", null);

    }

    private _onCloseSessionError(error) {

        console.error("_onCloseSessionError", error);

        this._setStyles("loggedIn");
    }

    private showMessage(message?: string, bError?: boolean) {
        if (!message) {
            this.hideNode(this.messageNode);

            message = "";
        } else {
            this.hideNode(this.messageNode, false);
        }

        domClass.toggle(this.domNode, "loginError");

        bError ? message ? console.error(message) : console.trace("error!") : message ? console.info(message) : console.trace("info");


        this.UiModder.domClass.toggle(this.messageNode, "warningCard", bError == true);

        this.UiModder.domAttr.set(this.messageNode, "innerHTML", message);
    }

    private _onSubstitutionsAvailable(data: Array<any>) {
        this._handleSubstitutionStyle();
    }
    private _handleSubstitutionStyle(bActive?: boolean) {

        let substCount = -1;
        if (typeof (bActive) == "undefined") {
            bActive = window.sessionInfo.isSubstitutionActive() == true;
        }

        let feature = this.hasFeature("System/enableUserSubstitution");

        if (feature) {
            substCount = window.sessionInfo.getAvailableUserSubstitutionCount();

        }

        this.hideNode(this.sectionSubstitution, !bActive && (!feature || substCount <= 0));
    }

    private _setStyles(state?: loginState) {
        this.hideNode(this.userInfoContainer, true);

        let loginContainer = this.loginContainer;
        let logoutContainer = this.logoutContainer;
        let btnLogout = this.btnLogout;
        let btnLogin = this.btnLogin;
        let loginHeaderContainer = this.loginHeaderContainer;

        let login = window.sessionInfo.sessionData;
        //console.debug("Loginform _setStyles", state);

        let actualUserName = window.sessionInfo.getUserName(true);
        let actualUserDisplay = window.sessionInfo.getUserDisplayName(true);
        if (actualUserDisplay == "" || actualUserDisplay == null || typeof (actualUserDisplay) == "undefined") {
            actualUserDisplay = actualUserName;
        }

        this.UiModder.domClass.add(this.sectionDeveloper, "hide w3-hide");
        //this.UiModder.domClass.add(this.userInfoContainer, "w3-hide");

        this.UiModder.domClass.remove(document.body, "logginOut loggingIn loggedOut loggedIn forwardingAfterLogin");
        this.UiModder.domClass.remove(this.domNode, "logginOut loggingIn loggedOut loggedIn forwardingAfterLogin");

        if (state) {
            this.UiModder.domClass.add(this.domNode, state);
            this.UiModder.domClass.add(document.body, state);
        } else {
            if (window.sessionInfo.isSessionOpen()) {
                this._setStyles("loggedIn");
                return;
            } else {
                this._setStyles("loggedOut");
                return;
            }
        }
        //this._checkProfilePicFeature();

        switch (state) {

            case "loggingOut": // gerade beim Logout
                this.UiModder.domClass.add(this.domNode, "loggedIn");
                // Logout-Button disablen
                //
                //this.showMessage("logge aus ...");
                this.btnLogout.setReadonly(true);
                this.UiModder.domClass.add(logoutContainer, "w3-disabled");
                //domAttr.set(loginContainer, "disabled", true);
                break;

            default:
            case "loggedOut":
                // ausgeloggt oder noch nicht eingeloggt
                // Loginbox anzeigen und enablen
                // Loginbutton anzeigen und enablen
                //this.showMessage("");
                this.UiModder.domClass.remove(loginContainer, "w3-hide w3-disabled");
                this.UiModder.domClass.remove(loginHeaderContainer, "w3-hide");
                this.UiModder.domClass.add(logoutContainer, "w3-hide");

                this.btnLogout.setReadonly(false);
                //domClass.remove(btnLogin, "w3-hide");
                btnLogin.setReadonly(false);
                this.hideNode(btnLogout);

                this._handleSubstitutionStyle(false);

                break;

            case "loggingIn":
                this.UiModder.domClass.add(this.domNode, "loggedOut");

                //this.showMessage("wird eingeloggt...");
                this.UiModder.domClass.add(loginContainer, "w3-disabled");
                btnLogin.setReadonly(true);
                break;

            case "forwardingAfterLogin":
                // eingeloggt - Seite lädt normal neu
                this.UiModder.domClass.add(loginContainer, "w3-hide");
                //domClass.add(btnLogin, "w3-hide");
                this.UiModder.domClass.add(loginHeaderContainer, "w3-hide");
                break;

            case "loggedIn":
                //this.showMessage("");
                this.UiModder.domClass.add(loginContainer, "w3-hide");
                this.UiModder.domClass.add(loginHeaderContainer, "w3-hide");
                this.btnLogout.setReadonly(false);
                this.UiModder.domClass.remove(logoutContainer, "w3-hide w3-disabled");
                this.hideNode(this.btnLogout, false);

                this._handleSubstitutionStyle();

                //this.UiModder.domAttr.set(this.usertext, "innerHTML", actualUserName);
                //this.UiModder.domAttr.set(this.userDisplaytext, "innerHTML", actualUserDisplay);
                //this.UiModder.domClass.remove(this.userInfoContainer, "w3-hide");


                let isSubstitute = window.sessionInfo.isSubstitutionActive();
                let userDisplaySubst = window.sessionInfo.getUserDisplayName();
                //this.hideNode(this.substituteUserInfoContainer, !isSubstitute);
                //if (isSubstitute) {
                //    this.UiModder.domAttr.set(this.substituteUsertext, "innerHTML", userDisplaySubst);
                //}

                if (this.hasUserRole("_DEV")) {
                    this.UiModder.domClass.remove(this.sectionDeveloper, "w3-hide hide");
                    if (window.customerSettings) {
                        this.UiModder.domAttr.set(this.txtFeatures, "innerHTML", JSON.stringify(window.customerSettings, null, 2));
                    }

                } else {
                    this.UiModder.domClass.add(this.sectionDeveloper, "hide w3-hide");
                }
                this.hideNode(this.userInfoContainer, false);

                if (this.hasFeature("User/MyProfileSection")) {
                    this.hideNode(this.sectionMyProfile, false);
                    this.requestMyProfileEntityView();
                };

                break;
        }

        this._showHide2FAuthButton();
        if (this.hasUserRole("MDSConnect_ProfileEditor") && this.hasFeature("System/EnableMDSConnectUI")){
            this.floatMenuConf["mdsConnect"].use = true;
        }else{
            this.floatMenuConf["mdsConnect"].use = false;
        }
        if (this.hasUserRole("Teams_Admin_Dashboard")){
            this.floatMenuConf["teamsAdmingPanel"].use = true;
        }else{
            this.floatMenuConf["teamsAdmingPanel"].use = false;
        }
    }

    private _onKeyDown_InputLogin(e: KeyboardEvent) {
        if (this.currentSession) return;

        if (this._loginRequestHandle) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }

    }
    private _onKeyUp_InputLogin(e: KeyboardEvent) {
        if (this.currentSession) return;
        if (this._loginRequestHandle) {

            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (e.key == "Enter") {
            this.executeLogin();
            e.stopPropagation(); /* wird sonst ggf an Checkbox 'angemeldet bleiben' durchgereicht - wollen wir nicht */
        } else {
            this._setLoginButtonStyle();
        }
    }

    private checkForExistingSession() {

        let data = window.sessionInfo.sessionData;

        //console.log("Loginform checkForExistingSession", data);


        this._onCheckForExistingSessionResult(data);

    }
    private _onClick_NavigateHome(evt) {
        location.href = window.appRoot;
    }

    private _checkReload(sessionResponse) {
        let bRedirect = false;

        if (sessionResponse != null) {

            if (sessionResponse.Exception == false) {
                bRedirect = !this.hasUserRole("_DEV");
                let action = this.getUrlAction().toLowerCase();
                bRedirect = bRedirect && action != "login";

                if (window.location.pathname.includes("/api/v1/proxy/") == true) { //reverse-proxy ms teams
                    bRedirect = true;
                }

                if (bRedirect != true && action != "login") {
                    console.info("keine Weiterleitung wegen DEV-Rolle!");
                    this.showMessage(
                        "Keine Weiterleitung wegen DEV-Rolle!<br>" +
                            "<button onclick='location.reload();' href='#' class='buttonBase primaryBtn smallBtn'>weiter zu: " +
                            (location.pathname == "/" ? "Home" : location.pathname) +
                        "</button>");
                }

            }
        }

        return bRedirect;
    }

    private _onCheckForExistingSessionResult(response: SessionData & TwoFactorProperties) {
        //domStyle.set(this.loginContainer, "display", "");
        this.hideNode(this.domNode, false);
        let login = response;//window.lastLoginResponse;
        let state: loginState = null;
        let reload = false;

        //console.log("_onCheckForExistingSessionResult", response, this.getUrlAction().toLowerCase(), document.getElementById("loginViewActive"));

        this.currentSession = response;

        if (login != null && typeof (login) != "undefined") {

            state = "loggedIn";
            //reload = typeof (document.getElementById("loginViewActive")) == "undefined"; //login.IsNewCreated == true;

            reload = this._checkReload(response);

        }

        this._setStyles(state);
        this._handleLoginResponse(response, reload);

        this.StandbyStop();
        this.UiModder.domClass.remove(this.loginContainer, "w3-disabled");


    }

    private _onCheckForExistingSessionError(error: more.requestErrorMessage) {
        //domStyle.set(this.loginContainer, "display", "");
        console.error("_onCheckForExistingSessionError", error.Message);
        this.StandbyStop();

    }

    private _onClick_ReleaseSessionsBtn() {
        let url = window.appRoot + "management/ReleaseAllPitSessions";
        this.RequestManager.post(
            url,
            {

            },
            lang.hitch(this, this._onReleaseAllPitSessionsResponse),
            lang.hitch(this, this._onReleaseAllPitSessionsResponse),
            false // sync
        );
    }

    private settingFloatMenu: MdsLax<InstanceType<typeof FloatingMenu>>;
    private floatMenuConf:{[key: string]:{use:boolean, floatConf:Object}} = {
        //changeProfilePic: {
        //    use:false,
        //    floatConf: {
        //        callback: lang.hitch(this, this._onClick_ProfilePic),
        //        label: this.translate("UserProfile__ChangeProfilePic"),
        //        heading: this.translate("LoginForm__FloatMenu_Heading_General"),
        //        groupname: "accConf",
        //        icon: "fas fa-user-circle",
        //        enabled: true
        //    },
        //},
        editProfile: {
            use: false,
            floatConf: {
                callback: lang.hitch(this, (this as any)._onClick_editProfile),
                label: (this as any).translate("LoginForm__EditProfile"),
                heading: (this as any).translate("LoginForm__FloatMenu_Heading_General"),
                groupname: "accConf",
                icon: "fas fa-pencil-alt",
                enabled: true
            }
        },
        changePass: {
            use:true,
            floatConf: {
                callback: lang.hitch(this, () => {
                    let passwordChange = new PasswordChangeHome();
                    passwordChange.setIsDialog(true);
                    passwordChange.show();
                }),
                label: (this as any).translate("ChangeUserPassword_changePwdBtnLabel"),
                heading: (this as any).translate("LoginForm__FloatMenu_Heading_General"),
                groupname: "accConf",
                icon: "fas fa-key",
                enabled: true
            }
        },
        //editMusicianProfile: {
        //    use: false,
        //    floatConf: {
        //        callback: lang.hitch(this, this._onClick_editMusicianProfile),
        //        label: this.translate("LoginForm__EditMusicianProfile"),
        //        heading: this.translate("LoginForm__FloatMenu_Heading_General"),
        //        groupname: "accConf",
        //        icon: "fas fa-music",
        //        enabled: true
        //    }
        //},
        googleSyncMgr:{
            use:false,
            floatConf: {
                callback: lang.hitch(this, (this as any)._onClick_OpenGoogleSyncManager),
                label: (this as any).translate("LoginForm__OpenGoogleSyncManager"),
                heading: (this as any).translate("LoginForm__FloatMenu_Heading_Connections"),
                groupname: "connections",
                icon: "fab fa-google",
                enabled: true
            }
        },
        tfaSetup:{
            use: true,
            floatConf: {
                callback: lang.hitch(this, (this as any)._onClick_setUp2FAuth),
                label: (this as any).translate("TwoFactorAuthenticator__enable2FactorAuth_btnLabel"),
                heading: (this as any).translate("LoginForm__FloatMenu_Heading_2FA"),
                groupname: "2fa",
                icon: "fas fa-fingerprint",
                enabled: true
            }
        },
        tfaDisable:{
            use: true,
            floatConf: {
                callback: lang.hitch(this, (this as any)._onClick_disable2FAuth),
                label: (this as any).translate("TwoFactorAuthenticator__disable2FactorAuth_btnLabel"),
                heading: (this as any).translate("LoginForm__FloatMenu_Heading_2FA"),
                groupname: "2fa",
                icon: "fas fa-ban",
                enabled: true
            }
        },
        mdsConnect:{
            use:true,
            floatConf:{
                callback: lang.hitch(this, ()=>{
                    let mdscEditor = new MDSCprofileEditor();
                    mdscEditor.showDlg();
                }),
                label: (this as any).translate("MDSConnect_ProfileMenu_Title"),
                heading: "SSO",
                groupname: "SSO",
                icon:"fas fa-user-tag",
                enabled:true
            }
        },
        teamsAdmingPanel:{
            use:false,
            floatConf:{
                callback: lang.hitch(this, ()=>{
                    let teamAdminPanel = new confpan();
                    teamAdminPanel.showDlg();
                }),
                label: (this as any).translate("MsTeamsIntegration_AdminPanel_Title"),
                heading: (this as any).translate("LoginForm__FloatMenu_Heading_Connections"),
                groupname: "connections",
                icon:"fab fa-microsoft",
                enabled:true
            }
        }
    }
    private _onClick_SettingsBtn(ev: Event) {
        let sessionData = window.sessionInfo?.sessionData;

        if (typeof this.settingFloatMenu != 'undefined') {
            try {
                this.settingFloatMenu.destroy();
            } catch { }
        }

        if (!sessionData) return;


        this.settingFloatMenu = new FloatingMenu();
        //this.floatMenuConf["changePass"].use = !this.passwordChange.passChangeIsNotAvailable;
        let userProperties = sessionData.UserProperties;
        if (userProperties) {
            this.floatMenuConf["changePass"].use = userProperties.disablePasswordChange !== true;
        }
        let entries = [];
        for (let key in this.floatMenuConf){
            if (this.floatMenuConf[key].use == true){
                entries.push(this.floatMenuConf[key].floatConf);
            }
        }
        this.settingFloatMenu.open(ev,
            entries,
        );
    }

    private settingHubMenu: MdsLax<InstanceType<typeof FloatingMenu>>;
    private hubMenuConf: { [key: string]: { use: boolean, floatConf: Object } } = {
        commObjects: {
            use: true,
            floatConf: {
                callback: lang.hitch(this, (this as any)._onClick_openCommunicationObjectList),
                label: (this as any).translate("General_Label_CommunicationEmail"),
                heading: (this as any).translate("LoginForm__FloatMenu_Heading_Communikation"),
                groupname: "communication",
                icon: "fas fa-envelope",
                enabled: true
            }
        }
    }
    private _onClick_HubBtn(ev: Event) {
        let sessionData = window.sessionInfo?.sessionData;

        if (typeof this.settingHubMenu != 'undefined') {
            try {
                this.settingHubMenu.destroy();
            } catch { }
        }

        if (!sessionData) return;

        this.settingHubMenu = new FloatingMenu();

        let entries = [];
        for (let key in this.hubMenuConf) {
            if (this.hubMenuConf[key].use == true) {
                entries.push(this.hubMenuConf[key].floatConf);
            }
        }
        this.settingHubMenu.open(ev,
            entries,
        );
    }
    private _onClick_openCommunicationObjectList() {

        var form = new CommunicationObjectList("userHub");

        form.show("dlg", this.translate("General_Label_CommunicationEmail"));
    }

    private _profilePicUploadData: any = null;

    private _onClick_ProfilePic() {

        //if (!window.sessionInfo) {
        //    console.warn("cannot change profile pic - sessionInfo is not ready");
        //    return;
        //}

        let dlg = new GenericDialog();
        dlg.setSize("smaller");
        dlg._setHeaderAttr(this.translate("UserProfile__ChangeProfilePic"));
        dlg.closeOnEnter = false;
        dlg.destroyOnClose = false;

        dlg.set("callback", lang.hitch(this, this.profilePicDlgCallback, dlg));

        let container = this.UiModder.domConstruct.create("div", { "id": "profilePicDlg" });
        let imageContainer = this.UiModder.domConstruct.create("div", { "className": "profilePicContainer empty" }, container);
        let deleteBtnContainer = this.UiModder.domConstruct.create("div", { "className": "deleteButtonContainer w3-panel w3-block w3-center" }, container);

        let image = this.UiModder.domConstruct.create("img", {
            "src": "",
            "className": "profilePic"
        }, imageContainer);


        let deleteBtn = this.UiModder.domConstruct.create("button", {
            "className": "deleteButton mds-button-base round hoverBright tertiaryBG w3-hide",
            "innerHTML": this.translate("General_Remove")
        }, deleteBtnContainer);

        let deleteIcon = this.UiModder.domConstruct.create("i", { "className": "fas fa-times deleteIcon" }, deleteBtn, "first");

        let upload = new SimpleFileUpload();
        this.UiModder.domClass.add(upload.domNode, "w3-block w3-panel hidden");
        upload.placeAt(container);
        upload.on("change", lang.hitch(this, this._serializeProfilePicData, upload, deleteBtn, image, imageContainer, dlg));
        upload.startup();

        on(deleteBtn, "click", lang.hitch(this, this.removeProfilePic, deleteBtn, image, imageContainer, upload, dlg));
        on(imageContainer, "click", lang.hitch(upload, upload.click));

        if (window.sessionInfo) {
            let data = window.sessionInfo.getProfilepicData()
            //console.debug("_onClick_ProfilePic current profiledata", data);
            if (data) {
                if (data.base64) {
                    //setUserdefinedButton(text: string, iconClass: string, callback: Function, bCloseOnClick?: boolean, bSecondaryButton?: boolean)
                    //dlg.setUserdefinedButton("entfernen", "fas fa-trash-alt", lang.hitch(this, this.removeProfilePic), false, true);

                    this.UiModder.domClass.remove(imageContainer, "empty");
                    this.UiModder.domAttr.set(image, "src", "data:image/jpeg;base64," + data.base64);
                    this.UiModder.domClass.remove(deleteBtn, "w3-hide");

                    //let input =
                }
                else {
                    upload.click();
                }
            }
        }


        //dlg.show();
        dlg.show(null, this.translate("UserProfile__ChangeProfilePic"), null, null, "close");
        dlg.addNodeToContent(container);


    }

    private _serializeProfilePicData(fileUpload, deleteBtn, image, imageContainer, dlg) {
        let data = fileUpload.getUploadData();
        this._profilePicUploadData = data;
        //console.debug("_serializeProfilePicData", data);

        if (data) {
            if (data.files) {
                if (data.files[0].Base64Content) {
                    this.UiModder.domAttr.set(image, "src", data.files[0].Base64Content);
                    this.UiModder.domClass.add(image, "changed");
                    this.UiModder.domClass.remove(imageContainer, "empty");
                    this.UiModder.domClass.remove(deleteBtn, "w3-hide");
                }
            }
        }



        dlg.set("closeBtn", false);
        dlg.set("cancelBtn", true);
        dlg.set("okBtn", true);
    }

    private profilePicDlgCallback(dlg, result) {
        //console.debug("profilePicDlgCallback", result);

        if (result >= 1) {
            //domClass.add(dlg.domNode, "w3-disabled");
            this.uploadProfilePic(dlg);
        } else {
            dlg.destroy();
        }
    }

    private removeProfilePic(deleteBtn, image, imageContainer, upload, dlg, evt) {
        if (evt) {
            evt.stopPropagation();
        }

        upload.reset();

        //console.debug("removeProfilePic");
        this.UiModder.domClass.add(deleteBtn, "w3-hide");
        this.UiModder.domAttr.set(image, "src", "");
        this.UiModder.domClass.add(imageContainer, "empty");

        this._profilePicUploadData = null;

        dlg.set("closeBtn", false);
        dlg.set("cancelBtn", true);
        dlg.set("okBtn", true);
    }

    private uploadProfilePic(dlg: MdsLax<InstanceType<typeof GenericDialog>>) {

        let url = window.appRoot + "Home/UploadWebuserProfilePic";

        let data = { "webuserID": window.sessionInfo.getCurrentWebuserId(true), "data": this._profilePicUploadData };

        this.RequestManager.post(url,
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onUploadProfilePicResponse, dlg),
            lang.hitch(this, this._onUploadProfilePicError, dlg)
        )
    }

    private _onUploadProfilePicResponse(dlg: MdsLax<InstanceType<typeof GenericDialog>>, response) {
        this.StandbyStop();

        dlg.destroy();

        this.StandbyStart();

        window.sessionInfo.checkForExistingSession();
    }

    private _onUploadProfilePicError(dlg: MdsLax<InstanceType<typeof GenericDialog>>, error: more.requestErrorMessage) {
        alert("error uploading profile pic:\r\n" + error.Message);

        //domClass.remove(dlg.domNode, "w3-disabled");
        dlg.show();

        this.StandbyStop();
    }

    private _onReleaseAllPitSessionsResponse(result) {
        if (result == "true" || result == true) {
            if (confirm("success! update userroles?") == true) {
                topic.publish("/Session/UpdateUserroles");
            }
            return;
        }
        alert(result);
    }

    private _ReleaseAllPitSessionsError(error: string) {
        console.error("Release Error", error);
    }

    private _onClick_UpdateUserroles(evt: MouseEvent) {
        let jsonData = "";

        let url = window.appRoot + "Session/UpdateWebuserRoles";
        this.RequestManager.post(
            url,
            {
                "jsonData": jsonData
            },
            lang.hitch(this, this._onUpdateUserroles),
            lang.hitch(this, this._onUpdateUserrolesError),
            false // sync
        );
    }

    private _onUpdateUserroles(result) {
        console.info("userroles updated: ", result);
    }

    private _onUpdateUserrolesError(error) {
        console.info("userroles update failed: ", error);
    }

    private _onClick_CurrentXXX(evt: MouseEvent) {
        let jsonData = "";

        let url = window.appRoot + "management/GetCurrentXXX";
        this.RequestManager.post(
            url,
            {
                "jsonData": jsonData
            },
            lang.hitch(this, "_devDisplayResult"),
            lang.hitch(this, "_devDisplayResult"),
            false // sync
        );
    }

    private _onClick_ToggleRoleDebug(evt) {
        let currentState = false;

        try {
            let data = JSON.parse(localStorage.getItem("ego_DebugUserroles"));
            currentState = data.state === true && data.userName == window.sessionInfo.getUserName();
        } catch (ex) {

        }

        currentState = !currentState;

        localStorage.setItem("ego_DebugUserroles", JSON.stringify({ state: currentState, userName: window.sessionInfo.getUserName() }));

        alert("debugging set to " + currentState.toString() + "; check console for results while testing");
    }

    private _onClick_OpenGoogleSyncManager(): void {
        let dlg = new GenericDialog();

        dlg.closeOnEnter = false;
        dlg.destroyOnClose = true;

        var form = new GoogleSyncManager();

        form.startup();

        dlg.show(form, this.getCurrentUserDisplayName(), null, null, "close");
    }

    private _onClick_editMusicianProfile(): void {
        let dlg = new GenericDialog();

        dlg.closeOnEnter = false;
        dlg.destroyOnClose = true;

        var form = new MusicianProfileForm();

        form.startup();
        form.loadMusicianProfileData();

        dlg.show(form, this.translate("General_Label_MusicianProfile"), null, null, "close");
    }

    private _onClick_editProfile(): void {
        let dlg = new GenericDialog();


        dlg.closeOnEnter = false;
        dlg.destroyOnClose = true;
        dlg.keepOpen = true;

        var profileForm = new UserProfileForm();

        profileForm.startup();
        profileForm.loadEmployeeData();

        dlg.show(profileForm, this.getCurrentUserDisplayName(), null, null, "saveclose", lang.hitch(this, this._onEditProfileDlgResponse, dlg, profileForm));
        dlg.disableButton("save");

        profileForm.on("change", lang.hitch(this, this._onChange_ProfileForm, dlg));
        profileForm.on("saved", lang.hitch(this, this._onSaved_ProfileForm, dlg));
    }

    private requestMyProfileEntityView() {
        this.hourGlassStart(this.sectionMyProfile);

        if (this.entityView) this.entityView.destroy();

        this.entityView = new GenericEntityView();

        this.entityView.setup({
            entityClass: "WebUser",
            entityId: this.getCurrentUserId(),
            label: "",
            contextName: "MyProfile",
            destination: this.myProfileEntityView,
            events: {
                onDataLoaded: () => { this.hourGlassEnd(this.sectionMyProfile); },
            }
        });

        this.entityView.hideIfEmpty(true, lang.hitch(this, this.hideNode, this.sectionMyProfile));
    }

    private _onChange_ProfileForm(dlg, isDirty) {
        dlg.enableButton("save", isDirty);
    }

    private _onEditProfileDlgResponse(dlg: MdsLax<InstanceType<typeof GenericDialog>>, form: MdsLax<InstanceType<typeof UserProfileForm>>, response: number) {
        if (response >= 1) {
            // save/ok/yes geklickt
            form.saveFormData();
        } else {
            // cancel geklickt
            dlg.close(-1, true);
        }
    }

    private _onSaved_ProfileForm(dlg) {
        dlg.close(-1, true);
    }

    private _onClick_ToggleDarkModeDebug() {
        topic.publish("Theme/RequestChange");
    }


    private _onThemesAvailable() {
        this.removeSubscription("Theme/ToggleAvailable");

        let toggler = new ThemeToggler();
        toggler.placeAt(this.sectionThemeToggle);

        toggler.startup();

        this.hideNode(this.sectionThemeToggle, false);
    }



    private _devDisplayResult(response) {
        alert(response);
    }

    private _onClick_setUp2FAuth() {
        location.href = window.appRoot + "home/TwoFactorAuthentication";
    }

    private _onClick_disable2FAuth(evt) {

        let dlg = new GenericDialog();


        let container = this.UiModder.domConstruct.create("div");

        this.UiModder.domConstruct.create("p", {
            innerHTML: this.translate("TwoFactorAuthenticator__disable2FactorAuth_confirmMessage")
        }, container);

        let codeInput = this.UiModder.domConstruct.create("input", {
            className: "w3-input border",

            id: "twoFactorAuthCodeInput"
        }, container);

        dlg.setSize("smaller");

        ///dlg.addButton("2fa", this.translate("TwoFactorAuthentication__dlgSubmitButton"), lang.hitch(this, this._disable2FAuth), null, null, null, true);

        dlg.show(container, "TwoFactorAuthenticator__disable2FactorAuth_btnLabel",
            null, null,
            "submitcancel",
            lang.hitch(this, this._disable2FAuthResult, codeInput, dlg));

        dlg.closeOnEnter = true;
        dlg.destroyOnClose = true;
        dlg.closeOnEscape = true;
        dlg.keepOpen = true;

    }

    private _disable2FAuthResult(input: HTMLInputElement, dlg: MdsLax<InstanceType<typeof GenericDialog>>, result: number) {
        if (result <= 0) {
            dlg.close(-1, true);
            return;
        }

        let code = input.value;

        if (!!code && code.length == 6) {

            this.RequestManager.post(
                window.appRoot + "Session/DisableTwoFactorAuthentication",
                {
                    token: code
                },
                lang.hitch(this, this._onDisable2FAuthResponse, dlg) as any,
                lang.hitch(this, this._onDisable2FAuthError, dlg)
            );

            dlg.disableAllButtons(true);

        } else {
            this.showToast("TwoFactorAuthentication__dlgInvalidCodeMessage", toasterIcons.warning);
            //alert(this.translate("TwoFactorAuthentication__dlgInvalidCodeMessage"));
        }
    }

    private _onDisable2FAuthResponse(dlg: MdsLax<InstanceType<typeof GenericDialog>>, response: string) {
        if (response == "success") {
            //alert(this.translate("TwoFactorAuthenticator__disable2FactorAuth_successMessage"));
            this.showToast("TwoFactorAuthenticator__disable2FactorAuth_successMessage");
            setTimeout(lang.hitch(location, "reload"), 200);
        } else {
            this._onDisable2FAuthError(dlg, response);
        }
    }

    private _onDisable2FAuthError(dlg: MdsLax<InstanceType<typeof GenericDialog>>, err: any) {

        if (err != "success" && err.Message != "success") {
            if (err && err.Message) {
                this.showToast(err.Message, toasterIcons.error);
            }
            console.error(err);

            dlg.disableAllButtons(false);
        } else {
            this._onDisable2FAuthResponse(dlg, "success");
        }
    }

    private _showHide2FAuthButton() {
        let sessionData = window.sessionInfo?.sessionData;

        if (!this.hasFeature("User/2FA")) {
            this.floatMenuConf["tfaSetup"].use = false;
            this.floatMenuConf["tfaDisable"].use = false;
            return;
        }

        if (sessionData) {

            let hide2FaSetupBtn = sessionData.IsTwoFactorAuthEnabled || sessionData.IsValidTwoFactorAuthentication
            this.floatMenuConf["tfaSetup"].use = !hide2FaSetupBtn;
            //this.hideNode(this.EnableTwoFAuthButton, sessionData.IsValidTwoFactorAuthentication);

            let hide2FaRemoveBtn = (!sessionData.IsValidTwoFactorAuthentication && !sessionData.IsTwoFactorAuthEnabled);
            hide2FaRemoveBtn = hide2FaRemoveBtn || sessionData?.IsTwoFactorAuthMandatory !== false;

            this.floatMenuConf["tfaDisable"].use = !hide2FaRemoveBtn;
        }
    }


    private _initialStandbyHandle: any = null;

    private _onClick_CheckFeature(evt) {
        let featurepath = this.inputFeaturepath.value;
        if (featurepath) {
            let result = this.hasFeature(featurepath);
            alert(featurepath + ": " + result.toString());
        }
    }

    postMixInProperties() {
        let self: any = this;
        super.postMixInProperties.apply(this, arguments as any);

        this.translations = window.translations;
        this.pageLinks = window.pageLinks;

        this.redirect = this.getUrlParameterValue("redir");
        this.removeUrlParameter("redir");
    }

    postCreate() {
        let self: any = this;
        super.postCreate.apply(this, arguments as any);

        this.addSubscription("/Session/CheckForExistingSession", lang.hitch(this, this.checkForExistingSession));
        this.addSubscription("/Session/SubstituteActive", lang.hitch(this, this._handleSubstitutionStyle));
        this.addSubscription("/Session/SubstutitionsAvailable", lang.hitch(this, this._onSubstitutionsAvailable));

        this.addSubscription("Theme/ToggleAvailable", lang.hitch(this, this._onThemesAvailable));

        this.addSubscription("/Session/InvalidSessionDataReceived", lang.hitch(this, (data:string)=>{
            this.showToast( {
                title: this.translate("LoginForm__InvalidSessionError"),
                iconClass: "fas fa-bomb",
                message: data,
                timeout: "permanent",
                showClose: true,
            } ); // Saml2 auth error msg
        }));

        if (this.hasFeature("System/DisableRememberLogin")) {
            this.cbRememberLogin.setValue(false, true);
            this.cbRememberLogin.setReadonly(true);
            this.hideNode(this.containerRememberLogin);
        }
        else if (this.hasFeature("System/RememberLoginDefaultOff")) {
            this.cbRememberLogin.setValue(false, true);
        }

        //buttons fuer Saml2 SSO
        if (this.hasFeature("System/ShowSaml2LoginButton")){
            this.samlLoginButtonContainer.classList.remove("w3-hide");
            this.MoreOptionsElement.classList.remove("w3-hide");
        }
        //button fuer MDSConnect
        if (this.hasFeature("System/EnableMDSConnectUI")){
            this.mdscLoginButtonContainer.classList.remove("w3-hide");
            this.MoreOptionsElement.classList.remove("w3-hide");
        }

        this.useStandbyManager = true;

        this.handleAutomaticLogin();


        //domAttr.set(this.privacy_text, "innerHTML", this.translations["Impressum__Datenschutz_Checkbox_TXT"]);

    }
    startup() {
        let self: any = this;
        super.startup.apply(this, arguments as any);

        if (this.domNode.parentElement) {
            this.hideNode(this.domNode.parentElement, false);
        }

        this._initialStandbyHandle = setTimeout(lang.hitch(this, this.StandbyStart), 10);

        this.hideNode(this.langSelect.domNode, !this.hasFeature("System/LanguageSelector"));

        if (this.hasFeature("System/PasswordReset")) this.hideNode(this.resetPasswordContainer, false);
        if (this.hasFeature("User/EmployeeProfileEditor")){
            this.floatMenuConf["editProfile"].use = true;
        };
        if (this.hasFeature("User/GoogleSyncManager")) {
            this.floatMenuConf["googleSyncMgr"].use = true;
        };
        if (this.hasFeature("User/UserHub")) {
            this.hideNode(this.hubBtnContainer, false);
        };

        if (this.hasFeature("System/ShowMainTitleOnLogin")) {
            this.setTitles(this.translate("MainTitle"), this.translate("MainTitle"));
        }
        this._handleSubstitutionStyle();

        //this.checkForExistingSession();

        //this.btnLogin.innerHTML = this.translations.LoginForm__Username...
    }
}

export default mdsWidget(LoginForm);
